import React from 'react'
import useLoad from '../functions/useLoad'
import { loadEvent, loadExhibitors } from '../apis/publicApi'
import { sectionForType, SHORTCODE_TYPES } from './sections/sectionForType'
import PlainLink from './PlainLink'
import { LABELS } from '../constants/staticText'
import LoadingIndicator from '../../lib/components/LoadingIndicator'

// Ein Messe-Abschnitt als Shortcode (#177): dieselben Abschnittskomponenten
// wie die Kachelseite (EventSectionView), aber auf einer beliebigen
// WordPress-Seite — etwa in Elementor. Kein Router, keine Breadcrumb; die
// Messe kommt als Slug herein, die Überschrift setzt der Shortcode statt der
// Kachel.
const EventSectionShortcode = ({ event: eventSlug, type, title }) => {
    const event = useLoad(() => loadEvent(eventSlug), [eventSlug])
    const exhibitors = useLoad(() => loadExhibitors(eventSlug), [eventSlug])

    const Section = SHORTCODE_TYPES.includes(type) ? sectionForType(type) : null
    if (!Section) return null

    if (event.loading || exhibitors.loading) {
        return <LoadingIndicator label={LABELS.loadingSection} />
    }
    if (event.error || exhibitors.error || !event.data) {
        return <p className="event-state">{LABELS.error}</p>
    }

    return (
        <section className="event-section event-section-shortcode">
            {title && <h2 className="event-section-title">{title}</h2>}
            <Section data={exhibitors.data} event={event.data} LinkComponent={PlainLink} />
        </section>
    )
}

export default EventSectionShortcode
